import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
const Fieldset = ({
  error = false,
  className,
  children,
  ...extraProps
}) =>
/*#__PURE__*/
// $FlowFixMe[cannot-spread-inexact]
_jsx("fieldset", {
  className: clsx({
    'form-group': true,
    'has-error': error
  }, className),
  ...extraProps,
  children: children
});
export default Fieldset;